import { createHttpAxiosBase } from "@ecommerce/http-setup";
import { authTokenStorage, userStorage } from "../utils/storage";
import { configuracion, getApiUrl } from "../configuration";

export const urlAPI = getApiUrl();

export const httpAxiosBase = createHttpAxiosBase({
    apiUrl: urlAPI,
    timeout: configuracion.apiTimeout,
    getAccessToken: () => authTokenStorage.getAccessToken(),
    getRefreshToken: () => authTokenStorage.getRefreshToken(),
    setAccessToken: (token: string) => {
        const refresh = authTokenStorage.getRefreshToken();
        if (refresh) {
            authTokenStorage.save(token, refresh);
        }
    },
    onLogout: () => {
        userStorage.removeFromStorage();
        window.location.href = "/login";
    },
});

export const axiosInstance = httpAxiosBase.instance;
export const axiosInstanceRefresh = httpAxiosBase.refreshInstance;
export const updateAxiosAuthHeader = httpAxiosBase.updateAuthHeader;

export const HttpAxiosBuilder = () => {
    return {
        get: httpAxiosBase.get,
        post: httpAxiosBase.post,
        put: httpAxiosBase.put,
        patch: httpAxiosBase.patch,
        delete: httpAxiosBase.delete,
        getWithQueryParamsSerializer: httpAxiosBase.getWithQueryParamsSerializer,
    };
};
